import initialState from './initialState';
import {
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_WORKING_SHIFT_GROUP,
} from '../../actions/account_working_shift_group/types';

export default function accountWorkingShiftGroup(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE:
      return {
        ...state,
        datos: [],
        error: action.payload,
        loading: false
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT:
      return {
        ...state,
        error: null,
        loadingTable: true
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS:
      return {
        ...state,
        datos: action.concat ? state.datos.concat(action.payload.data) : action.payload.data,
        error: null,
        status: action.payload.status,
        loadingTable: false
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE:
      return {
        ...state,
        loadingTable: false,
        status: 500
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT:
      return {
        ...state,
        error: null
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        error: null,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE:
      return {
        ...state,
        count: {},
        error: action.payload
      };
    case CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT:
      return{
        ...state,
        error: null,
        loadingSave: true, 
      };
    case CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS:
      return{
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false, 
        statusSave: action.payload.status
      };
    case CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE:
      return{
        ...state,
        loadingSave: false, 
        status: 500
      };
    case UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case RESET_MODAL:
      return {
        ...state,
        loadingSave: false,
        statusSave: null,
        dataSave: {}
      };
    case RESET_ACCOUNT_WORKING_SHIFT_GROUP:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/account_working_shift_group/index.js